import React from "react";

import { useAgentMatchBehavior } from "../../redux/hooks/agentMatchHooks";
import { useUIBehavior } from "../../redux/hooks/uiHooks";
import * as S from "./styled";

const ConnectWithAgentCTA = () => {
  const { openExpertMatchDrawer } = useUIBehavior();
  const { fetchAgentMatches } = useAgentMatchBehavior();

  const contactButtonClickHandler = () => {
    openExpertMatchDrawer();
    fetchAgentMatches();
  };

  return (
    <S.Container>
      <S.Title>Contact an Agent About Selling</S.Title>
      <S.Content>
        <S.Text>
          Looking to sell? Talk strategy with an expert who knows this
          neighborhood & price point.
        </S.Text>
        <S.CTAImage />
      </S.Content>
      <S.ContactAgentButton onClick={contactButtonClickHandler}>
        Contact Agent
      </S.ContactAgentButton>
    </S.Container>
  );
};

export default ConnectWithAgentCTA;
